import { observable, action, computed} from 'mobx';
import {dcUnitsStore, shipment, storageStore, time} from '../index';
import settings from '../cultureSettings.json'

export default class Parent{

    @observable totalCapacity;
    @observable amount;
    @observable culture;
    @observable moistureLevel;
    @observable wasteLevel;
    @observable scenario;
    @observable status;
    @observable active;
    @observable name;
    @observable currentOperation;

    constructor(num, culture = 'None', scenario = [], amount=0, moistureLevel, wasteLevel, status, name=''){
        this.num = num;
        this.amount = amount;
        this.culture = culture;
        this.moistureLevel = moistureLevel;
        this.wasteLevel = wasteLevel;
        this.scenario = scenario;
        this.status = status;
        this.active = false;
        this.name = name;
        this.currentOperation = -1;
        this.errorStatus = '';
    }

    @action initScenario(script,operation){
        this.scenario = script;
        this.currentOperation = operation;
    }


    @action setUnit(amount=0, culture="None", moisture=0, waste=0, active=false){
        this.amount = amount;
        this.culture = culture;
        this.moistureLevel = moisture;
        this.wasteLevel = waste;
        this.active = active;
        this.status='';
        this.statusErr='';

        if(this.type !=='bunker' && this.type !=='silo') {this.initScenario([],0)}
    }

    @computed get getScenarioLength(){
        return this.scenario.length;
    }

    @computed get nextOperationItem(){
        return this.scenario[this.currentOperation]
    }

    @action mixingTest(){
        if(this.nextOperationItem.culture !== 'None' && this.nextOperationItem.culture !== this.culture){
            this.status = this.nextOperationItem.status = 'clogged';
            this.errorStatus = this.nextOperationItem.errorStatus = "Змішання культур!!!";
            console.log("Змішання культур!!!",this.nextOperationItem.type);
            return false;
        }
        return true;
    }

    @action amountTest(){
        if( this.nextOperationItem.totalCapacity && this.nextOperationItem.totalCapacity*settings[this.culture].volume <= this.nextOperationItem.amount){
            this.status = this.nextOperationItem.status = 'clogged';
            this.errorStatus = this.nextOperationItem.errorStatus = "Недостатньо місця!!!";
            console.log("Недостатньо місця в следующем элементе сценария",this.nextOperationItem.type);
            return false;
        }
        return true;
    }
    @action DCTest(){
        if((this.nextOperationItem.type === 'drying' || this.nextOperationItem.type === 'cleaning') && this.nextOperationItem.amount){
            return false
        }
        return true
    }
    @action scenarioTest(){
        if(!!this.nextOperationItem.getScenarioLength && this.nextOperationItem.type !== 'silo' && this.nextOperationItem.type !== 'hopper' &&
            ((this.getScenarioLength !== this.nextOperationItem.getScenarioLength) || this.nextOperationItem.scenario[0].type !== this.scenario[0].type || this.nextOperationItem.scenario[0].num !== this.scenario[0].num)){
            this.status = 'clogged';
            this.errorStatus = "Наступний елемент зайнятий іншим сценарієм!!!";
            console.log("Наступний елемент зайнятий іншим сценарієм",this.nextOperationItem.type);
            return false;
        }
        return true;
    }

    @action nextItemErrorStatusTest(){
        if(this.nextOperationItem.status === 'clogged' && !this.nextOperationItem.totalCapacity){
            this.status  = 'clogged';
            this.errorStatus = "Наступний елемент сценарію забитий!!!";
            console.log("Наступний елемент сценарію забитий",this.nextOperationItem.type);
            return false;
        }
        return true;
    }

    @action setErrorStatus(status ='', errorStatus =''){
        this.status = this.nextOperationItem.status = status;
        this.errorStatus = errorStatus;
    }

    @action baseTest(){
        if (this.nextOperationItem.type === 'output') {
            if(this.moistureLevel > settings[this.culture].baseMoisture || this.wasteLevel > settings[this.culture].baseWaste) {
                this.status = this.nextOperationItem.status = 'clogged';
                this.errorStatus = "Не соответствует базовым показателям сорности/влажности!!!";
                console.log("Не соответствует базовым показателям сорности/влажности!!!");
                return false;
            }else{
                let find =this.nextOperationItem.findTransport(this.culture);
                if((this.nextOperationItem.activeTransport.disabled  || this.nextOperationItem.activeTransport.culture !== this.culture) && find === -1){
                    this.status = this.nextOperationItem.status = 'clogged';
                    this.errorStatus = this.nextOperationItem.errorStatus = "Недостатньо транспорту!!!";
                    console.log("Недостатньо транспорту!!!");
                    return false;
                }
            }
        }
        return true;
    }

    @action checkUnit(speed = 10){
        if(this.amount <= 0 && this.culture !== 'None'){
            this.setUnit();
        }else{
            if(this.getScenarioLength && this.culture !== 'None'){
                if(!this.active){
                    this.active = true
                }
                if(this.currentOperation !== this.getScenarioLength -1 && this.scenarioTest()) {
                    this.nextOperationItem.initScenario(this.scenario, this.currentOperation + 1);
                }
                if(this.nextOperationItem.culture === 'None'){
                    this.nextOperationItem.setUnit(0,this.culture);
                }
                if(this.mixingTest() && this.amountTest() && this.scenarioTest() && this.baseTest() && this.nextItemErrorStatusTest() && this.DCTest()){
                    if(this.nextOperationItem.type === 'cleaning'){
                        this.nextOperationItem.setSpeed((this.wasteLevel < (settings[this.culture].baseWaste)) ?
                            (this.nextOperationItem.speedParams[this.culture].min)
                            :
                            (this.wasteLevel > (settings[this.culture].critWaste) ?
                                    (this.nextOperationItem.speedParams[this.culture].max)
                                    :
                                    ((((this.wasteLevel - settings[this.culture].critWaste) * (this.wasteLevel - settings[this.culture].critWaste)) *
                                        (this.nextOperationItem.speedParams[this.culture].min - this.nextOperationItem.speedParams[this.culture].max)) /
                                        ((settings[this.culture].critWaste - settings[this.culture].baseWaste) * (settings[this.culture].critWaste - settings[this.culture].baseWaste))) +
                                    this.nextOperationItem.speedParams[this.culture].max
                            ));

                        this.shippingFrom(this.nextOperationItem.speed/60*time.tickCoef)
                    }else{
                        if(this.nextOperationItem.type === 'drying'){
                            this.nextOperationItem.setSpeed(((this.moistureLevel < (settings[this.culture].baseMoisture)) ?
                                    (this.nextOperationItem.speedParams[this.culture].min)
                                            :
                                (this.moistureLevel > (settings[this.culture].critMoisture) ?
                                        (this.nextOperationItem.speedParams[this.culture].max)
                                        :
                                            ((((this.moistureLevel-settings[this.culture].critMoisture)*(this.moistureLevel-settings[this.culture].critMoisture))*
                                                (this.nextOperationItem.speedParams[this.culture].min-this.nextOperationItem.speedParams[this.culture].max))/
                                                ((settings[this.culture].critMoisture - settings[this.culture].baseMoisture)*(settings[this.culture].critMoisture - settings[this.culture].baseMoisture))) +
                                            this.nextOperationItem.speedParams[this.culture].max
                            )));
                            this.shippingFrom(this.nextOperationItem.speed/60*time.tickCoef)
                        }else{
                            if(this.nextOperationItem.type === 'output'){
                                this.shippingFrom(this.nextOperationItem.getOutputSpeed())
                            }else {
                                this.shippingFrom(speed)
                            }
                        }
                    }
                }
            }else{
                if(this.status === 'clogged'){
                    this.status = this.statusErr = '';
                }
                if(this.active){
                    this.active = false
                }
            }
        }
    }

    @action shippingFrom(speed){
        if(this.status === 'clogged'){
            this.status = this.statusErr = '';
        }
        let rem = this.amount - speed;
        if(!this.nextOperationItem.totalCapacity){
            if(rem < 0) {
                this.nextOperationItem.filling(this.culture, this.amount,this.wasteLevel, this.moistureLevel );
                this.amount = 0;
            }else{
                this.nextOperationItem.filling(this.culture, speed,this.wasteLevel, this.moistureLevel);
                this.amount -= speed;
            }
        }else{
            let delta = this.nextOperationItem.totalCapacity*settings[this.culture].volume - this.nextOperationItem.amount;
            if(rem < 0){
                if(delta <= this.amount){
                    this.nextOperationItem.filling(this.culture,delta,this.wasteLevel,this.moistureLevel);
                    this.amount -= delta;
                }else{
                    this.nextOperationItem.filling(this.culture,this.amount,this.wasteLevel,this.moistureLevel);
                    this.amount = 0;
                }
            }else{
                if(delta <= speed){
                    this.nextOperationItem.filling(this.culture,delta,this.wasteLevel,this.moistureLevel);
                    this.amount -= delta;
                }else{
                    this.nextOperationItem.filling(this.culture,speed,this.wasteLevel,this.moistureLevel);
                    this.amount -= speed;
                }
            }
        }
    }

    @action filling(culture,delta,waste,moisture){
        if(this.culture === culture) {
            this.moistureLevel = Math.round(((this.amount * this.moistureLevel) + (delta * moisture)) / ((this.amount + delta) / 10000)) / 10000;
            this.wasteLevel = Math.round(((this.amount * this.wasteLevel) + (delta * waste)) / ((this.amount + delta) / 10000)) / 10000;
            this.amount += delta;
        }else {
            console.log('filling error')
        }
    }

}



// WEBPACK FOOTER //
// ./src/shared/stores/objects/parent.js